export const InvoiceSQ = {
  seller: "Shitësi ",
  nui: "Numri Unik Identifikues ",
  vatNR: "Numri i TVSH-së",
  addres: "Adresa",
  phone: "Tel",
  email: "Email",
  buyer: "Blerësi",
  city: "Qyteti",
  document: "Dokumenti",
  number: "Numri",
  invDate: "Data Faturës",
  payDate: "Afati Pageses",
  user: "Përdoruesi",
  unit: "Njesia Organizative:01",
  barcode: "Barkodi",
  itemDesc: "Emertimi",
  qty: "Sasia",
  artUnit: "Njesia",
  priceNoVAT: "Cmimi pa TVSH",
  amountNoVAT: "Vlera pa TVSH",
  vatRates: "Norma",
  rabat: "Rabati",
  vat: "TVSH",
  priceWithVAT: "Cmimi Me TVSH",
  amountWithVAT: "Vlera Me TVSH",
  price: "Cmimi",
  amount: "Vlera",
  normaTatimore: "Norma Tatimore",
  base: "Baza",
  total: "Total",
  tvshLlogaritur0: "TVSH e llogaritur (A) 0%",
  tvshLlogaritur8: "TVSH e llogaritur (D) 8%",
  tvshLlogaritur18: "TVSH e llogaritur (E) 18%",
  vleraPaRabat: "Vlera pa rabat:",
  totalNoVAT: "Total pa TVSH:",
  totalVAT: "Total TVSH",
  payment: "Për pagesë",
  desc1: "Pagesa duhet të bëhet deri në afatin e pagesës së caktuar",
  desc2: "Ju faleminderit për bashkëpunimin tuaj!",
  comment: "Komenti",
  confirm: "Konfirmuar",
  vulaEl: "VULA ELEKTRONIKE",
  faturoi: "Faturoi",
  dergoi: "Dergoi",
  pranoi: "Pranoi",
  desc3:
    "Ju lutem, pagesen tuaj per shumen e pergjithshme ta beni ne njeren nga llogarit bankare vijuese te kompanis",
  bank: "Banka",
  accName: "Emri Llogaris",
  accNumber: "Numri Llogaris",
  swift: "Swift Kodi",
  buyerInfo: "Informatat e blerësit",
};

export const InvoiceEN = {
  seller: "Seller",
  nui: "Unique Identification Number",
  vatNR: "VAT Number",
  addres: "Address",
  phone: "Phone",
  email: "Email",
  buyer: "Buyer",
  city: "City",
  document: "Document",
  number: "Number",
  invDate: "Invoice Date",
  payDate: "Payment Deadline",
  user: "User",
  unit: "Organizational Unit:01",
  barcode: "Barcode",
  itemDesc: "Description",
  qty: "Quantity",
  artUnit: "Unit",
  priceNoVAT: "Price Without VAT",
  amountNoVAT: "Amount Without VAT",
  vatRates: "Rate",
  rabat: "Discount",
  vat: "VAT",
  priceWithVAT: "Price With VAT",
  amountWithVAT: "Amount With VAT",
  price: "Price",
  amount: "Amount",
  normaTatimore: "Tax Rate",
  base: "Base",
  total: "Total",
  tvshLlogaritur0: "Calculated VAT (A) 0%",
  tvshLlogaritur8: "Calculated VAT (D) 8%",
  tvshLlogaritur18: "Calculated VAT (E) 18%",
  vleraPaRabat: "Value Without Discount:",
  totalNoVAT: "Total Without VAT:",
  totalVAT: "Total VAT",
  payment: "Due Payment",
  desc1: "The payment should be made by the specified payment deadline",
  desc2: "Thank you for your cooperation!",
  comment: "Comment",
  confirm: "Confirmed",
  vulaEl: "ELECTRONIC STAMP",
  faturoi: "Invoiced by",
  dergoi: "Sent by",
  pranoi: "Received by",
  desc3:
    "Please, make your payment for the total amount in one of the following bank accounts of the company",
  bank: "Bank",
  accName: "Account Name",
  accNumber: "Account Number",
  swift: "Swift Code",
  buyerInfo: "Buyer Details",
};
